import * as React from 'react';


interface ScrollContainerProps {
  useWrapper: boolean;
}

export const ScrollContainer: React.FC<React.PropsWithChildren<ScrollContainerProps>> = (props) => {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const resize = React.useCallback(() => {
    if (ref.current == null)
      return;

    let refTop: number = 0;
    let element: HTMLElement = ref.current;
    while (element) {
      refTop += element.offsetTop;
      element = element.offsetParent as HTMLElement;
    }

    const top: number = window.innerHeight - refTop - 4;
    ref.current.style.maxHeight = `${top}px`;
  }, [ref]);

  React.useEffect(() => {
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [resize]);


  return (
    <div className="scroll-container" ref={ref}>
      {
        props.useWrapper &&
        <div>{props.children}</div>
      }
      {
        !props.useWrapper &&
        props.children
      }
    </div>
  );
}